<template>
  <popup-bg :show-lock="showLock" :loading-lock="loadingLock">
    <div slot="custom-html">
      <div class="popup-qrcode-wrap">
        <div class="qrcode-content" v-if="imgs.jp">
          <h3>日本报名采集表</h3>
          <img :src="imgs.jp">
        </div>
        <div class="qrcode-content" v-if="imgs.jp">
          <h3>韩国报名采集表</h3>
          <img :src="imgs.ko">
        </div>
        <div class="qrcode-tips">长按二维码以保存至相册</div>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>
<script>
import popupBg from './popupBg';

export default {
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    crmId: {
      type: Number,
      required: true,
    },
    resetLock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imgs: { jp: '', ko: '' },
      loadingLock: false
    };
  },
  components: {
    'popup-bg': popupBg
  },
  methods: {
    getQrcode(id) {
      if (!id) {
        return false;
      }
      this.loadingLock = true;
      this.$http._post({
        url: '/index/student/createQr',
        data: { id }
      }).then((data) => {
        if (data.data.jp === '' && data.data.ko === '') {
          this.$message.error('当前学生没有二维码');
          this.$emit('update:showLock', false);
        } else {
          this.imgs = data.data;
        }
        this.loadingLock = false;
      });
    }
  },
  mounted() {
    this.getQrcode(this.crmId);
  },
  watch: {
    showLock(v) {
      if (this.resetLock) {
        if (!v) {
          this.imgs = { jp: '', ko: '' };
        } else {
          this.getQrcode(this.crmId);
        }
      }
    }
  }
};
</script>

<style scoped>
  .popup-qrcode-wrap{
    max-height: 72vh;
    width: 100%;
    overflow: auto;
    padding: 8vw 5vw;
    text-align: center;
  }
  .popup-qrcode-wrap .qrcode-content{
    display: inline-block;
    text-align: center;
    width: 32vw;
    margin: 0 3vw;
  }
  .popup-qrcode-wrap .qrcode-content h3{
    font-size: 3.73vw;
    padding-bottom: 3vw;
  }
  .popup-qrcode-wrap .qrcode-content img{
    width: 27.2vw;
    height: 27.2vw;
  }
  .popup-qrcode-wrap .qrcode-tips{
    font-size: 3.73vw;
    text-align: center;
    padding: 4vw 0 0;
    color: #333;
  }
</style>
